import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

import './WarningBanner.css';

const isDev = process.env.NODE_ENV !== 'production';

export const WarningBanner = () => {
    const [tooltipIsOpen, setTooltipIsOpen] = useState(true);
    const [tooltipMessage, setTooltipMessage] = useState('');

    useEffect(() => {
        let cancelled = false;

        axios
            .get('https://dq.arm.gov/dqo-webtool-status-files/dq-plotbrowser-status.json')
            .then((res) => {
                if (cancelled) return;
                const json = res.data;

                if (isDev) {
                    console.log('[WarningBanner] response:', json);
                }

                if (json && json.status_text) {
                    setTooltipMessage(json.status_text);
                } else if (isDev) {
                    console.warn('[WarningBanner] status_text missing. Keys:', Object.keys(json));
                }
            })
            .catch((err) => {
                if (!cancelled && isDev) {
                    console.error('[WarningBanner] Request failed:', err);
                }
            });

        return () => { cancelled = true; };
    }, []);

    if (!tooltipMessage) return null;

    return (
        <div onClick={() => setTooltipIsOpen((prev) => !prev)} className="WarningBannerContainer">
            <Tooltip open={tooltipIsOpen} title={tooltipMessage} position="left">
                <p><i className="WarningIcon fas fa-exclamation-triangle" /></p>
            </Tooltip>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/WarningBanner.js